


































































import { Component, Vue } from "vue-property-decorator";
import { SocialEntry } from "@/api/models/SocialEntry";
import { ContactEntry } from "@/api/models/ContactEntry";

@Component
export default class Footer extends Vue {
    /**
     * Get the social entries.
     */
    get socials(): Array<SocialEntry> {
        return require("@/api/content/socials.json");
    }

    /**
     * Get the contact entries.
     */
    get contacts(): Array<ContactEntry> {
        return require("@/api/content/contact.json");
    }
}
